import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { t } from "i18next";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Password } from "primereact/password";
import SettingService from "../../SettingService";

type CreateSubAccountProps = {
  isCreateAccount: boolean;
  onHide: () => void;
  showSuccess: () => void;
};
const CreateSubAccounts = (props: CreateSubAccountProps) => {
  const [fname, setFName] = useState<string>("");
  const [lname, setLName] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [usersRole, setUsersRole] = useState<boolean>(false);
  const [projectsRole, setProjectsRole] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>([]);

  const settingService = new SettingService();

  const validation = () => {
    let error: any = [];
    if (fname === "") {
      error["fname"] = t("fname_error");
      setErrors(error);
    }
    if (lname === "") {
      error["lname"] = t("lname_error");
      setErrors(error);
    }

    if (userName === "") {
      error["username"] = t("username_error");
      setErrors(error);
    }
    if (email === "") {
      error["email"] = t("email_error");
      setErrors(error);
    }
    if (password === "") {
      error["password"] = t("password_error");
      setErrors(error);
    }
    if (confirmPassword === "") {
      error["confirm_password"] = t("confirm_password_error");
      setErrors(error);
    }
    if (confirmPassword != password) {
      error["password_unmatch"] = t("password_match_error");
      setErrors(error);
    }
    if (usersRole == false && projectsRole == false) {
      error["role_error"] = t("role_error");
      setErrors(error);
    }

    if (Object.keys(error).length !== 0) {
      return false;
    }

    return true;
  };

  const createUser = () => {
    setErrors([]);
    if (validation()) {
      let rights = { projectRole: projectsRole, userRole: usersRole };
      let data = {
        first_name: fname,
        last_name: lname,
        username: userName,
        email: email,
        password: password,
        rights: rights,
      };
      settingService.createSubUser(data).then((response) => {
        if (response == 200) {
          props.onHide();
          props.showSuccess();
        } else if (response == 400) {
          let error: any = [];
          error["username_found"] = "The username or email already exists.";
          setErrors(error);
        }
      });
    }
  };

  const footerContent = (
    <div>
      <Button
        label={t("cancel")}
        icon="pi pi-times"
        onClick={() => props.onHide()}
        className="p-button-text"
      />
      <Button
        label={t("save")}
        icon="pi pi-check"
        onClick={() => createUser()}
        autoFocus
      />
    </div>
  );
  return (
    <>
      <Dialog
        header={t("create") + " " + t("sub_accounts")}
        visible={props.isCreateAccount}
        style={{ width: "50vw" }}
        footer={footerContent}
        onHide={() => props.onHide()}
      >
        <div className="grid align-items-center">
          <div className="lg:col-6">
            <div className="grid align-items-center">
              <div className="col-12 lg:col-4">
                <h5 className="mb-2 ml-5">{t("fname")}:</h5>
              </div>
              <div className="col-12 lg:col-8">
                <InputText
                  className="p-inputtext-sm mt-2"
                  value={fname}
                  onChange={(e) => setFName(e.target.value)}
                />
                <p className="error-message">{errors["fname"]}</p>
              </div>
              <div className="col-12 lg:col-4">
                <h5 className="mb-2 ml-5">{t("username")}:</h5>
              </div>
              <div className="col-12 lg:col-8">
                <InputText
                  className="p-inputtext-sm mt-2"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
                <p className="error-message">{errors["username"]}</p>
                <p className="error-message">{errors["username_found"]}</p>
              </div>
              <div className="col-12 lg:col-4">
                <h5 className="mb-2 ml-5">{t("password")}:</h5>
              </div>
              <div className="col-12 lg:col-8">
                <Password
                  className="p-inputtext-sm"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  feedback={false}
                  toggleMask
                />
                <p className="error-message">{errors["password"]}</p>
                <p className="error-message">{errors["password_unmatch"]}</p>
              </div>
              <div className="col-12 lg:col-4">
                <h5 className="mb-2 ml-5">{t("add_edit_projects")}:</h5>
              </div>
              <div className="col-12 lg:col-8">
                <Checkbox
                  onChange={(e) => setProjectsRole(e.checked)}
                  checked={projectsRole}
                />
              </div>
            </div>
          </div>

          <div className="lg:col-6">
            <div className="grid align-items-center">
              <div className="col-12 lg:col-4">
                <h5 className="mb-2 ml-5">{t("lname")}:</h5>
              </div>
              <div className="col-12 lg:col-8">
                <InputText
                  className="p-inputtext-sm mt-2"
                  value={lname}
                  onChange={(e) => setLName(e.target.value)}
                />
                <p className="error-message">{errors["lname"]}</p>
              </div>
              <div className="col-12 lg:col-4">
                <h5 className="mb-2 ml-5">{t("email")}:</h5>
              </div>
              <div className="col-12 lg:col-8">
                <InputText
                  className="p-inputtext-sm mt-2"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <p className="error-message">{errors["email"]}</p>
                <p className="error-message">{errors["username_found"]}</p>
              </div>
              <div className="col-12 lg:col-4">
                <h5 className="mb-2 ml-5">{t("confirm_password")}:</h5>
              </div>
              <div className="col-12 lg:col-8">
                <Password
                  className="p-inputtext-sm mt-2"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  feedback={false}
                  toggleMask
                />
                <p className="error-message">{errors["confirm_password"]}</p>
                <p className="error-message">{errors["password_unmatch"]}</p>
              </div>
              <div className="col-12 lg:col-4">
                <h5 className="mb-2 ml-5">{t("add_edit_users")}:</h5>
              </div>
              <div className="col-12 lg:col-8">
                <Checkbox
                  onChange={(e) => setUsersRole(e.checked)}
                  checked={usersRole}
                />
              </div>
            </div>
          </div>
          <p className="error-message">{errors["role_error"]}</p>
        </div>
      </Dialog>
    </>
  );
};

export default CreateSubAccounts;
